import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const GetStartedSection = () => {
  return (
    <Box
      sx={{
        backgroundColor: '#f9fafb',
        py: 4,
        borderRadius: 2,
        textAlign: 'center',
        mt: 6,
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="h4"
          component="h2"
          sx={{
            fontWeight: 'bold',
            mb: 3,
            color: '#000000',
          }}
        >
          Get Started with Vertex Suite Today
        </Typography>
        <Box sx={{ mb: 4 }}>
          <Typography
            variant="body1"
            sx={{
              display: 'inline-block',
              mr: 2,
              color: 'rgb(5, 78, 146)',
            }}
          >
            <CheckCircleIcon sx={{ verticalAlign: 'middle', mr: 0.5 }} /> Engage & Re-engage Prospects
          </Typography>
          <Typography
            variant="body1"
            sx={{
              display: 'inline-block',
              mr: 2,
              color: 'rgb(5, 78, 146)',
            }}
          >
            <CheckCircleIcon sx={{ verticalAlign: 'middle', mr: 0.5 }} /> Drive Sales
          </Typography>
          <Typography
            variant="body1"
            sx={{
              display: 'inline-block',
              mr: 2,
              color: 'rgb(5, 78, 146)',
            }}
          >
            <CheckCircleIcon sx={{ verticalAlign: 'middle', mr: 0.5 }} /> Deliver higher CSAT
          </Typography>
          <Typography
            variant="body1"
            sx={{
              display: 'inline-block',
              color: 'rgb(5, 78, 146)',
            }}
          >
            <CheckCircleIcon sx={{ verticalAlign: 'middle', mr: 0.5 }} /> Support at Scale
          </Typography>
        </Box>
        <Button
          variant="contained"
          sx={{
            backgroundColor: 'rgb(5, 78, 146)',
            color: '#ffffff',
            padding: '10px 30px',
            '&:hover': {
              backgroundColor: 'rgb(27, 96, 160)',
            },
          }}
        >
          Contact Us
        </Button>
      </Container>
    </Box>
  );
};

export default GetStartedSection;